import { getMessages } from '../../../../../../../store/constants';

export const LEARN_MORE_TEMPLATES = getMessages().getText('aside_panel.learn_more.templates');
export const LEARN_MORE_RECURRING = getMessages().getText('aside_panel.learn_more.recurring');
export const NO_CARDS_YET = getMessages().getText('aside_panel.no_cards_yet');
